// Meta Pixel só em páginas de aquisição (site, blog, cadastro de empresa).
// Nunca no sistema logado: custa rede/CPU e não mede nada útil lá.
const PIXEL_ID = '1157378985022780'
// Nomes exatos (âncoras nas duas pontas): `site-home` e as variações por segmento
// (`site-home-lavarapido`, `site-home-oficina`...), `blog`, `blog-details` e
// `cadastroempresa`. Nenhuma rota do /sistema tem nome que case aqui.
const ROTAS_COM_PIXEL = /^(site-home(-[a-z]+)?|blog|blog-details|cadastroempresa)$/

let pixelCarregado = false

// Snippet oficial do fbevents.js, só que injetado sob demanda na primeira rota
// de aquisição em vez de ir no HTML de todas as páginas.
const carregarPixel = () => {
    if (pixelCarregado) return
    pixelCarregado = true

    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    // Sem isto o fbevents escuta pushState/popstate e dispara PageView sozinho a
    // cada troca de rota da SPA — inclusive dentro do /sistema, se o visitante
    // for do site para o login na mesma sessão — e ainda duplica o PageView
    // manual abaixo. Precisa estar setado antes do `init`.
    window.fbq.disablePushState = true
    window.fbq('init', PIXEL_ID)
}

// Chamado no `afterEach` do router (inclusive na navegação inicial). O PageView
// manual é a única fonte de PageView. Marketing nunca pode quebrar a navegação.
export const registrarPageViewDoPixel = (rota) => {
    try {
        if (!rota || typeof rota.name !== 'string' || !ROTAS_COM_PIXEL.test(rota.name)) return
        carregarPixel()
        window.fbq('track', 'PageView')
    } catch (e) {
        // silencioso: bloqueador de anúncio, CSP etc.
    }
}
